import { useEffect } from "react";
import { visitApi } from "../services/api";

const { addVisitLog } = visitApi;

export const TrackVisit = () => {
  useEffect(() => {
    // 获取或生成会话 ID（整个会话周期唯一）
    let sessionId = sessionStorage.getItem("session_id");
    const isNewSession = !sessionId;

    if (!sessionId) {
      sessionId = generateUUID();
      sessionStorage.setItem("session_id", sessionId); // 存储会话 ID
      sessionStorage.setItem("session_start", Date.now()); // 存储会话开始时间
    }

    console.log(sessionId, isNewSession);

    // 只在首次进入页面时统计访问
    if (isNewSession) {
      const trackData = {
        // sessionId,
        visitorId: localStorage.getItem("user_id") || generateUUID(), // 长期用户 ID
        // path: window.location.pathname,
        // referrer: document.referrer,
        // userAgent: navigator.userAgent,
        // screenWidth: window.screen.width,
        // isNewUser: !localStorage.getItem("user_id"), // 是否新用户
      };

      addVisitLog({ ...trackData }).catch((err) => {
        console.log(err);
      });

      // 标记长期用户 ID（如果未设置）
      if (!localStorage.getItem("user_id")) {
        localStorage.setItem("user_id", trackData.visitorId);
      }
    }

    // 页面关闭时清理 sessionStorage
    const handleBeforeUnload = () => {
      sessionStorage.removeItem("session_id");
      sessionStorage.removeItem("session_start");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return null;
};

// 生成 UUID
const generateUUID = () => {
  return window.crypto.randomUUID();
};
